import {
  classSet,
  Table as LibraryTable,
  TableProps as LibraryTableProps
} from '@platform/ui-library';
import { FC } from 'react';
import styles from './Table.module.scss';

type TableProps = (
  LibraryTableProps
  & {
    /**
     * @asTable Indicates if the table divs should be styled as a HTML table.
     * If no className is provided, it will use a table-layout: fixed
     * (all columns have the same width).
     */
    asTable?: boolean;
    className?: string;
  }
);

export const Table: FC<TableProps> = ({
  asTable,
  className,
  ...tableProps
}) => {
  return (
    <LibraryTable
      tableStyle={{
        theme: {
          table: classSet([styles.table, asTable && styles.asTable, className ?? (asTable && 'layout-fixed')]),
          thead: styles.thead,
          tbody: styles.tbody
        }
      }}
      { ...tableProps }
    />

  );
};
